module.exports = __webpack_public_path__ + "img/yt.4207696c.png";